import DataMapper from './DataMapper'
import AddressChangeRequestRM from '../responsemodel/AddressChangeRequestRM'
import AddressChangeRequest from "../../models/AddressChangeRequest"

class AddressChangeRequestDataMapper extends DataMapper<AddressChangeRequestRM, AddressChangeRequest> {
    map = (rm: AddressChangeRequestRM) => new AddressChangeRequest(rm._id, rm.address, rm.isAddressChange, rm.name, rm.tempNewAddress, rm.addressChangeReqTime)
}
export default AddressChangeRequestDataMapper